const { getElements } = window.BAO.Utils

class YotpoPointsRewards extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    this.pointsRowEls = getElements('.ytp-PointsRewards_PointsRow', {
      context: this,
    })

    // eslint-disable-next-line compat/compat
    this.observer = new IntersectionObserver(this.onEntry.bind(this), {
      threshold: 0,
    })

    this.observer.observe(this.pointsRowEls[0])
  }

  onEntry ([entry], observer) {
    if (!entry.isIntersecting) return

    this.pointsRowEls.forEach((pointsRowEl, index) => {
      setTimeout(() => {
        pointsRowEl.dataset.visible = 'true'
      }, index * 1000)
    })

    observer.unobserve(this.pointsRowEls[0])
  }
}

if (!customElements.get('yotpo-points-rewards')) {
  customElements.define('yotpo-points-rewards', YotpoPointsRewards)
}
